import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface User {
  _id: string;
  user_id: string;
  email: string;
  name: string;
  role: string;
}

interface UsersState {
  users: User[];
  currentUser: User | null;
  loading: boolean;
  error: string | null;
}

const initialState: UsersState = {
  users: [],
  currentUser: null,
  loading: false,
  error: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<User | null>) => {
      state.currentUser = action.payload;
    },
    clearUsersError: (state) => {
      state.error = null;
    },
  },
});

export const { setCurrentUser, clearUsersError } = usersSlice.actions;
export default usersSlice.reducer;
